<script lang="ts">
	import type { ClassValue } from "svelte/elements";
	import Formatted from "./common/Formatted.svelte";
	import Heading from "./common/Heading.svelte";

	const {
		title,
		description,
		class: customClass,
	}: { title: string; description: string; class: ClassValue } = $props();
</script>

<article
	class={["p-4 sm:p-8 flex flex-col gap-3 [counter-increment:how-it-works] my-[var(--container-gap)]", customClass]}
>
	<div
		class={[
			"bg-fcrbeige size-10.5 flex justify-center items-center rounded-full",
			"text-5/tighter font-antipol text-fcrdarkgray after:content-[counter(how-it-works)]",
		]}
	></div>
	<Heading level={3} class="text-5/tighter font-antipol text-white mt-2" text={title} />
	<p class="text-xs/tighter text-white">
		<Formatted text={description} />
	</p>
</article>
